import { useAuth } from 'react-oidc-context';

import { Center, Group, Paper, Text, Title } from '@mantine/core';

import { ProductLink, useAvailableProducts } from '@/entities/product';

export function ProductsPage() {
  const products = useAvailableProducts();
  const { user } = useAuth();

  return (
    <Center h="100%">
      <Paper withBorder py={20} px={24} radius="lg">
        <Text size="xs" tt="uppercase" ta="center" ff="mono" fw={600} mb={8}>
          {`Hello, ${user?.profile?.given_name}!`}
        </Text>

        <Title order={3} ta="center" mb={60}>
          There are the following apps available for you.
          <br />
          Please, choose which one you want to visit.
        </Title>

        <Group gap={16} align="center" justify="center">
          {products.map(product => (
            <ProductLink key={product.name} product={product} variant="standalone" />
          ))}
        </Group>
      </Paper>
    </Center>
  );
}
